import { yupResolver } from '@hookform/resolvers/yup';
import { GuestHotelScheduleLiteModel } from 'api-hooks/cro/model';
import { useUpdateHotelSchedule } from 'api-hooks/cro/mutation';
import { croKey } from 'api-hooks/cro/query';
import { queryClient } from 'common/repositories/query-client';
import notification from 'components/common/notification';
import Separator from 'components/common/separator';
import { Form, Input } from 'components/elements';
import React from 'react';
import { useForm } from 'react-hook-form';

import {
  HotelScheduleFormSchema,
  HotelScheduleFormType,
} from './hotel-schedule-form-type';
import HotelScheduleStatusSelect from './hotel-schedule-status-select';
import HotelScheduleTable from './hotel-schedule-table';

interface HotelScheduleFormProps {
  data: GuestHotelScheduleLiteModel[];
  onClose: () => void;
}

export default function HotelScheduleForm(props: HotelScheduleFormProps) {
  const defaultValues = React.useMemo<HotelScheduleFormType>(() => {
    return {
      data: props.data,
      hotelSchedules: props.data.map((detail) => {
        return {
          ...detail,
          checkInStatus: detail.checkInStatus,
          id: detail.id,
          isCheck: false,
          hotelConfirmationCode: detail.hotelConfirmationCode || '',
        };
      }),
    };
  }, [props.data]);

  const methods = useForm({
    defaultValues,
    resolver: yupResolver(HotelScheduleFormSchema()),
  });

  const { mutateAsync } = useUpdateHotelSchedule();

  const onSubmit = React.useCallback(
    async (values: HotelScheduleFormType) => {
      try {
        const result = await mutateAsync(values);
        notification.success({
          message: result.message,
        });
        queryClient.refetchQueries([croKey.hotelSchedulesKey()[0]]);

        props.onClose();
      } catch (e) {
        if (e.errors) {
        }
        notification.error({
          message: e.message,
        });
      }
    },
    [mutateAsync, props],
  );

  return (
    <Form onSubmit={onSubmit} methods={methods}>
      <HotelScheduleStatusSelect />
      <Separator gap={16} />
      <HotelScheduleTable />
      <Separator gap={16} />
      <Input type="submit" />
    </Form>
  );
}
